var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "content mb-4" }, [
      _c("span", { staticClass: "NameSpan" }, [
        _vm._v("Bitte wählen Sie eine Merkliste aus"),
      ]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.SelectedWishList,
              expression: "SelectedWishList",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { required: "" },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.SelectedWishList = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        _vm._l(_vm.WishList, function (item) {
          return _c("option", { domProps: { value: item.wishlistid } }, [
            _vm._v(
              "\n                " +
                _vm._s(item.wishlistname) +
                "\n            "
            ),
          ])
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wishlistCheckbox", attrs: { hidden: "" } }, [
      _c("input", { attrs: { type: "checkbox" } }),
      _vm._v(" "),
      _c(
        "span",
        { staticStyle: { "font-size": "12px !important", top: "-3px" } },
        [_vm._v("Alle weiteren Artikel direkt zu dieser Merkliste hinzufügen")]
      ),
      _vm._v(" "),
      _vm.AddError
        ? _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wishlist-footer" }, [
      _c("div", [
        _c("input", {
          staticClass: "first-btn",
          attrs: { type: "button", value: "Speichern" },
          on: {
            click: function ($event) {
              return _vm.AddToWishList()
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          staticClass: "second-btn",
          attrs: { type: "button", value: "Schließen" },
          on: {
            click: function ($event) {
              return _vm.modalClose()
            },
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header pb-4" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Merkliste auswählen")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }